import { gql } from '@apollo/client';
import {
  CORE_ATTACHMENTS_FIELDS,
  CORE_CHAT_MESSAGES_FIELDS,
} from 'src/components/providers/apollo-provider-provider';

export const CONTACT_INTERACTION_CHANNEL_AVAILABILITY_FOR_CONTACT = gql`
  query ContactInteractionChannelAvailabilityForContact($contactId: Int!) {
    contactInteractionChannelAvailabilityForContact(contactId: $contactId) {
      channel {
        slug
        name
      }
      resources {
        ... on ContactInteractionChannelResource {
          id
          address
          displayName
        }
        ... on ContactInteractionChannelPhoneResource {
          phoneNumber {
            national
          }
        }
        ... on ContactInteractionChannelSmsResource {
          unavailableReasonCode
          phoneNumber {
            national
          }
        }
        ... on ContactInteractionChannelWhatsappResource {
          unavailableReasonCode
          phoneNumber {
            national
          }
          waba
          isActive
          bannedState {
            violation
            date
          }
        }
      }
      lastUsedResourceId
      lastInteractionContactAddress
      isAvailable
      lastInteractionDate
      unavailableReasonCode
      contactAddresses
      contactIdentifiers {
        value
        label
      }
      resourceToContactAddressAvailability {
        resourceId
        contactAddress
        displayName
        type
        expiresAt
        unavailableReasonCode
      }
    }
  }
`;

export const CONVERSATION_SEND_SMS = gql`
  ${CORE_ATTACHMENTS_FIELDS}
  ${CORE_CHAT_MESSAGES_FIELDS}
  mutation ConversationSendSms(
    $conversationId: ID!
    $message: String!
    $fromResourceId: Int
    $contactPhoneType: ContactPhoneType
    $attachments: [ConversationSendContactInteractionFileAttachmentInput!]
  ) {
    conversationSendSms(
      conversationId: $conversationId
      message: $message
      fromResourceId: $fromResourceId
      contactPhoneType: $contactPhoneType
      attachments: $attachments
    ) {
      interaction {
        id
        direction
        ...ContactInteractionChatMessagesFragment
        ...ContactInteractionAttachmentsFragment
      }
    }
  }
`;

export const CONVERSATION_SEND_FACEBOOK_MESSAGE = gql`
  ${CORE_ATTACHMENTS_FIELDS}
  ${CORE_CHAT_MESSAGES_FIELDS}
  mutation ConversationSendFacebookMessage(
    $conversationId: ID!
    $message: String!
    $attachments: [ConversationSendContactInteractionFileAttachmentInput!]
    $resourceId: ID
  ) {
    conversationSendFacebookMessage(
      conversationId: $conversationId
      message: $message
      attachments: $attachments
      resourceId: $resourceId
    ) {
      interaction {
        id
        direction
        ...ContactInteractionChatMessagesFragment
        ...ContactInteractionAttachmentsFragment
      }
    }
  }
`;

export const ADD_INTERNAL_NOTE = gql`
  mutation AddConversationNote(
    $conversationId: String!
    $noteText: String!
    $rawNoteText: String!
    $mentions: [Int!]
  ) {
    conversationAddInternalNote(
      conversationId: $conversationId
      noteText: $noteText
      rawNoteText: $rawNoteText
      mentions: $mentions
    ) {
      note {
        id
        text
        rawNote
        createdBy {
          id
          fullName
        }
      }
    }
  }
`;

export const CONVERSATION_SEND_WHATSAPP_MESSAGE = gql`
  ${CORE_ATTACHMENTS_FIELDS}
  ${CORE_CHAT_MESSAGES_FIELDS}
  mutation conversationSendWhatsappMessage(
    $conversationId: ID!
    $message: String!
    $resourceId: ID!
    $contactAddress: String
    $attachments: [ConversationSendContactInteractionFileAttachmentInput!]
  ) {
    conversationSendWhatsappMessage(
      conversationId: $conversationId
      message: $message
      resourceId: $resourceId
      contactAddress: $contactAddress
      attachments: $attachments
    ) {
      interaction {
        id
        direction
        ...ContactInteractionChatMessagesFragment
        ...ContactInteractionAttachmentsFragment
      }
    }
  }
`;

export const CONVERSATION_SEND_INSTAGRAM_MESSAGE = gql`
  ${CORE_ATTACHMENTS_FIELDS}
  ${CORE_CHAT_MESSAGES_FIELDS}
  mutation conversationSendInstagramMessage(
    $conversationId: ID!
    $message: String!
    $resourceId: ID!
    $attachments: [ConversationSendContactInteractionFileAttachmentInput!]
  ) {
    conversationSendInstagramMessage(
      conversationId: $conversationId
      message: $message
      resourceId: $resourceId
      attachments: $attachments
    ) {
      interaction {
        id
        direction
        ...ContactInteractionChatMessagesFragment
        ...ContactInteractionAttachmentsFragment
      }
    }
  }
`;

export const GET_CONTACT_CONTACT_INFORMATION = gql`
  query GetContactContactInformation($id: Int!) {
    contact(id: $id) {
      id
      primaryPhone {
        national
        e164
        countryCode
        regionCode
      }
      secondaryPhone {
        national
        e164
        countryCode
        regionCode
      }
    }
  }
`;
